<script setup lang="ts">
export interface Props {
  total?: number;
}
const props = withDefaults(defineProps<Props>(), {
  total: 0,
});
</script>

<template>
  <div :class="$style.tableTotalCmn" data-testid="tableTotalCmn">
    Found {{ props.total }}
    <template v-if="props.total === 1">result</template>
    <template v-else>results</template>
  </div>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
.tableTotalCmn {
  font-size: 0.875rem;
  white-space: nowrap;
}
</style>
